// extracted by mini-css-extract-plugin
export default {"userManagement":"UserManagement_userManagement__rdn3U","contentTitle":"UserManagement_contentTitle__mRXLI"};